import React from 'react';
import PropTypes from 'prop-types';
import { CustomsStatus } from './sections/status';
import { CustomsWidgetHeader } from './sections/header';
import { CustomsDeclarationsSection } from './sections/declarations';
import { CustomsWidgetFooter } from './sections/footer';
import { CustomsStoreCurrencyWarning } from './sections/status/warnings/customs-store-currency-warning';

export const CustomsWidget = ({ fulfillmentPlanId, children }) => (
  <>
    <CustomsStatus fulfillmentPlanId={fulfillmentPlanId} />
    <CustomsWidgetHeader />
    {children}
    <CustomsStoreCurrencyWarning />

    <CustomsDeclarationsSection readOnly={false} />
    <CustomsWidgetFooter />
  </>
);

CustomsWidget.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  children: PropTypes.node,
};
